module.exports = __webpack_public_path__ + "img/lucas-wakamatsu-leopard.99d10cd.jpg";